export class CustomHeaders {
  public static readonly ResponseTime: string = 'X-Response-Time-Milliseconds';
  public static readonly Authorization: string = 'Authorization';
  public static readonly RefreshToken: string = 'Refresh-Token';
  public static readonly TokenExpired: string = 'Token-Expired';
  public static readonly InvalidTimestamp: string = 'Invalid-Timestamp';
}
